/**
 * Feature Flags Configuration
 * 
 * This file manages feature flags for different environments.
 * Features can be enabled/disabled based on environment variables.
 */

// Read AI features flag from environment variable
// This is set via .github/envs/{environment} files during deployment
const AI_FEATURES_ENABLED = process.env.REACT_APP_ENABLE_AI_FEATURES === 'true';

// The chatbot's beta/AI disclaimer is on unless explicitly turned off with
// REACT_APP_CHATBOT_DISCLAIMER_ENABLED=false — a missing variable must not silently drop
// the notice while the assistant is still in beta.
const AI_CHATBOT_DISCLAIMER_ENABLED = process.env.REACT_APP_CHATBOT_DISCLAIMER_ENABLED !== 'false';

// Feature flags configuration
export const featureFlags = {
  AI_CHATBOT: AI_FEATURES_ENABLED,
  AI_CHATBOT_DISCLAIMER: AI_CHATBOT_DISCLAIMER_ENABLED,
};

// Helper function to check if a feature is enabled
export const isFeatureEnabled = (featureName) => {
  return featureFlags[featureName] === true;
};

// Log feature flags status in development
if (process.env.NODE_ENV === 'development') {
  console.log('AI Features Enabled:', AI_FEATURES_ENABLED);
  console.log('Feature Flags:', featureFlags);
}
